// extracted by mini-css-extract-plugin
export default {"inputWrapper":"MonthInput_inputWrapper__paguN","label":"MonthInput_label__bdazl","rightArrowBtn":"MonthInput_rightArrowBtn__DQXyL","leftArrowBtn":"MonthInput_leftArrowBtn__yHKSr"};